import React, { Component } from 'react';
import { connect } from 'react-redux';
import { actions } from '../../config/reduxIndex';
import { Redirect } from 'react-router-dom';

class RoutingContainer extends Component {
	state = {
		redirect: false
	}

	componentWillReceiveProps(nextProps) {
		const redirect = nextProps.redirect;
		this.setState({redirect})
	}

	render() {
		return this.state.redirect ? this.redirect() : null;
	}

	redirect = () => {
		return <Redirect to = { this.state.redirect } />
	}
}
function mapStateToProps(state) {
	return {
		redirect: state.routing.redirect
	}
}

export default connect(mapStateToProps, null)(RoutingContainer);


// WEBPACK FOOTER //
// ./src/containers/shared/RoutingContainer.jsx